import gql from 'graphql-tag';

export class UserLanguage {
  languageid?: number ;
  language?: string;
  shortname?: string;
}
